/* @ngInject */
const stringToId = (
  valueHandler
) => {
  return (item) => {
    if (valueHandler.isNull(item) || !valueHandler.isString(item)) {
      return item
    }

    if (!item.replace(/\s/g, '').match(new RegExp('^[0-9-]{13}$'))) {
      return item
    }

    let res = ''
    const id = item.toString()
    res += id.slice(0, 2)
    res += id.slice(3, 5)
    res += id.slice(6, 9)
    res += id.slice(10, 14)
    res += id.slice(17, 18)

    return res
  }
}

export default stringToId



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/filters/entities/wagon/stringToId.filter.js